import React, { memo, forwardRef } from "react";
const SvgPsi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M16.024 28a1 1 0 01-1-1v-4.544c-1.216-.048-2.28-.272-3.192-.672-.896-.416-1.592-1.088-2.088-2.016C9.248 18.84 9 17.584 9 16v-5.624a1 1 0 011-1h.088a1 1 0 011 1v5.696c0 1.2.168 2.128.504 2.784.352.656.824 1.112 1.416 1.368a6.65 6.65 0 002.016.48V5a1 1 0 011-1h.064a1 1 0 011 1v15.68c.912-.08 1.68-.312 2.304-.696.64-.384 1.128-.944 1.464-1.68.336-.736.504-1.664.504-2.784 0-.736-.032-1.432-.096-2.088a20.635 20.635 0 00-.24-1.968c-.047-.276-.1-.56-.159-.85-.127-.634.348-1.238.994-1.238h.032c.463 0 .867.317.963.77.167.791.293 1.55.378 2.278.128.96.192 1.968.192 3.024 0 1.648-.28 2.976-.84 3.984-.544.992-1.296 1.728-2.256 2.208-.944.464-2.024.736-3.24.816V27a1 1 0 01-1 1h-.064z"
      />
    </svg>
  );
});
SvgPsi.displayName = "SvgPsi";
const MemoForwardRef = memo(SvgPsi);
export default MemoForwardRef;
